
/**
 * Get selected user
 * @returns userObject from localstorage
 */
 export const getSelectedUser = () => {
    return JSON.parse(localStorage.getItem('user'));
  };


  /**
 * Get Float
 * @returns branchObject from localstorage
 */
 export const getLocalFloat = () => {
  return JSON.parse(localStorage.getItem('float'));
};


/**
 * Round the decimal numbers correctly. To force 10c use.
 * @param {Number} num 
 * @returns
 * https://stackoverflow.com/questions/11832914/how-to-round-to-at-most-2-decimal-places-if-necessary
 * 
 * LineItemAddEdit.js
 * TransactionTableView.js
 * 
 * 
 * 
 */
export const roundCents = (num) => {    
  return Number((+(Math.round(num + "e+2")  + "e-2")).toFixed(1));
}



/**
 * Round the decimal cents to two places. To force 10c use.
 * @param {Number} num 
 * @returns
 * https://stackoverflow.com/questions/11832914/how-to-round-to-at-most-2-decimal-places-if-necessary
 * 
 * LineItemAddEdit.js
 * TransactionTableView.js
 * 
 * 
 * 
 * 
 * 
 */
export const roundCentsTotal = (num) => {    
  return Number((+(Math.round(num + "e+1")  + "e-1")));
}

// test functiom
// const roundCents = (num) => {    
//   return Number((+(Math.round(num + "e+1")  + "e-1")).toFixed(1));
// }

// let val = Number(roundCents(3.45).toFixed(2));

// console.log(val);


/**
 * Calulate the VAT
 * @param {gross}
 * @param {tare}
 * @param {excPrice} - selected excluding price
 * @param {vatRate}
 * @returns Vat Total
 */
//  const calulate_vatTotal = (gross, tare, excPrice, vatRate, deduction) => {
//   return Number(
//     // ((gross - tare) * excPrice * vatRate - (gross - tare) * excPrice).toFixed(4)
//     roundCents(
//       (
//         (((gross - tare) - deduction) * excPrice) 
//         * vatRate
//       ) - (
//         ((gross - tare) - deduction) * excPrice
//       )
//     )
//   );
// };


/**
 * Calulate the SubTotal (exc)
 * @param {gross}
 * @param {tare}
 * @param {excPrice} - selected excluding price
 * @returns SubTotal
 */
//  const calulate_subTotal = (gross, tare, excPrice, deduction) => {
//   return Number(((gross - tare) - deduction) * excPrice);
// };